import View from './View';

export { default as View } from './View';
export { default as getSettingsButtonStyles } from './styles';
export const useViewModel = (props) => props;

export default View;
